import classnames from 'classnames';
import { Waypoint } from 'react-waypoint';
import Sections from '~/constants/vdp/sections';
import { useHasOwnerReviews } from '~/context/vdp/StarRatingOwnerReviewContext';
import { useIsNewVehicle } from '~/context/vdp/VehicleContext';
import useIsInspectionCompleted from '~/hooks/vdp/selectors/useIsInspectionCompleted';
import useShouldDisplayOrderStatus from '~/hooks/vdp/selectors/useShouldDisplayOrderStatus';
import useShouldShowPriceDetails from '~/hooks/vdp/selectors/useShouldShowPriceDetails';
import UpArrow from '~/icons/UpArrow';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import {
  DesktopPageNavigationWrapper,
  DesktopStickyPageNavigationInnerWrapper,
  DesktopStickyPageNavigationWrapper,
  NavigationButton,
  NavigationColumnOne,
  NavigationColumnTwo,
  NavigationTab,
  NavigationTabIndicator,
  NavigationText
} from './DesktopPageNavigation.styles';
import { useCurrentSection, useSticky } from './hooks';
import { useShouldImport } from '../VehicleDetailsContainer/hooks';

const topOffset = 137; // It's maaaaagiiiic....

const DesktopPageNavigation = () => {
  const currentSection = useCurrentSection(topOffset);
  const shouldShowPriceDetails = useShouldShowPriceDetails();
  const shouldDisplayOrderStatus = useShouldDisplayOrderStatus();
  const hasOwnerReviews = useHasOwnerReviews();
  const { isSticky, updateStickyState } = useSticky();
  const analyticsId = isSticky ? 'Sticky Header' : 'Navbar';
  const displayPriceDetailsNav =
    shouldShowPriceDetails && !shouldDisplayOrderStatus;
  const { importRecalls } = useShouldImport();
  const isNewVehicle = useIsNewVehicle();
  const showInspection =
    useIsInspectionCompleted() && (!isNewVehicle || importRecalls);

  return (
    <>
      <DesktopPageNavigationWrapper>
        <Waypoint
          topOffset={78}
          onEnter={updateStickyState}
          onLeave={updateStickyState}
        />
      </DesktopPageNavigationWrapper>
      <DesktopStickyPageNavigationWrapper
        data-qa="desktop-sticky-page-navigation-wrapper"
        id="desktop-navigation"
      >
        <DesktopStickyPageNavigationInnerWrapper
          className={classnames({ 'box-shadow': isSticky })}
        >
          <NavigationColumnOne>
            {isSticky && (
              <NavigationButton
                href={`#${Sections.Root}`}
                data-analytics-id="Nav - Top"
              >
                <UpArrow />
                <NavigationText className="mx-8">Top</NavigationText>
              </NavigationButton>
            )}
          </NavigationColumnOne>
          <NavigationColumnTwo>
            <NavigationTab
              href={`#${Sections.FeaturesAndHighlights}`}
              data-analytics-id={analyticsId}
              data-analytics-attributes={JSON.stringify({
                label: 'Key Features'
              })}
            >
              <NavigationText>Key Features</NavigationText>
              {currentSection === Sections.FeaturesAndHighlights && (
                <NavigationTabIndicator />
              )}
            </NavigationTab>
            <NavigationTab
              href={`#${Sections.VehicleDetails}`}
              data-analytics-id={analyticsId}
              data-analytics-attributes={JSON.stringify({
                label: 'Vehicle Details'
              })}
            >
              <NavigationText>Vehicle Details</NavigationText>
              {currentSection === Sections.VehicleDetails && (
                <NavigationTabIndicator />
              )}
            </NavigationTab>
            {displayPriceDetailsNav && (
              <NavigationTab
                href={`#${Sections.PriceDetails}`}
                data-analytics-id={analyticsId}
                data-analytics-attributes={JSON.stringify({
                  label: 'Price Details'
                })}
              >
                <NavigationText>Price Details</NavigationText>
                {currentSection === Sections.PriceDetails && (
                  <NavigationTabIndicator />
                )}
              </NavigationTab>
            )}
            {hasOwnerReviews && (
              <NavigationTab
                href={`#${Sections.OwnerReviews}`}
                data-analytics-id={analyticsId}
                data-analytics-attributes={JSON.stringify({
                  label: 'Owner Reviews'
                })}
              >
                <NavigationText>Owner Reviews</NavigationText>
                {currentSection === Sections.OwnerReviews && (
                  <NavigationTabIndicator />
                )}
              </NavigationTab>
            )}
            {showInspection && (
              <NavigationTab
                href={`#${Sections.Inspection}`}
                data-analytics-id={analyticsId}
                data-analytics-attributes={JSON.stringify({
                  label: 'Inspection'
                })}
              >
                <NavigationText>Inspection</NavigationText>
                {currentSection === Sections.Inspection && (
                  <NavigationTabIndicator />
                )}
              </NavigationTab>
            )}
            <NavigationTab
              href={`#${Sections.RecommendedVehicles}`}
              data-analytics-id={analyticsId}
              data-analytics-attributes={JSON.stringify({
                label: 'Recommended Vehicles'
              })}
            >
              <NavigationText>More Cars</NavigationText>
              {currentSection === Sections.RecommendedVehicles && (
                <NavigationTabIndicator />
              )}
            </NavigationTab>
          </NavigationColumnTwo>
        </DesktopStickyPageNavigationInnerWrapper>
      </DesktopStickyPageNavigationWrapper>
    </>
  );
};

export default withErrorBoundary(DesktopPageNavigation);
